













import { Component, Vue, Prop } from 'vue-property-decorator';
import AuthModal from '@/components/modals/AuthModal.vue';
import Footer from '@/components/Footer.vue';
import Notification from '@/components/Notification.vue';

@Component({
  components: {
      AuthModal,
      Footer,
      Notification
  },
})
export default class Home extends Vue {
    @Prop(String) background: string
}
